import { Component, OnInit, ViewChild, ElementRef, OnDestroy, Input } from '@angular/core';
import { NavParams } from '@ionic/angular';

import { SAMService } from 'src/app/sam/sam.service';
import { SAM } from 'src/app/sam/base/sam';
import { CartService } from 'src/app/services/cart.service';
import { SAMMessage } from 'src/app/sam/interfaces/sam-message';
import { ThemeService } from 'ngx-elvis-ds';
import { BasePage, Helpers } from 'ngx-elvis-ds';
import { I18NService } from 'src/app/services/i18n.service';
import { ConfigService } from 'src/app/config.service';

@Component({
  selector: 'app-numeric-input-dialog',
  templateUrl: './numeric-input-dialog.page.html',
  styleUrls: ['./numeric-input-dialog.page.scss'],
})
export class NumericInputDialogPage extends BasePage implements OnInit, OnDestroy {

  @ViewChild('keyboard', { static: true }) keyboard: ElementRef;
  @Input() data: any;

  osdValue: String;
  inputOptions: any = {};
  inputData: any = '';
  reasonData: any = '';
  rewardData: any = '';
  digitsInfo: any = '0.0-0';
  divider: number = 1;
  valueLabel: string = ' ';
  formName: string = 'form' + Helpers.hash();

  constructor(
    public i18nSvc: I18NService,
    public themeSvc: ThemeService,
    public configSvc: ConfigService,
    private sam: SAMService,
  ) {
    super();
    this.subscribeListeners();
  }

  ngOnInit() {
    this.init();
  }

  ngOnDestroy() {
    this.unsubscribeListeners();
  }

  onCallback(success: boolean) {
    document.removeEventListener('keydown', this.initKeyboard);
    if (success) {
      if (this.inputData) {
        if (this.inputData.toString() === 'NaN') { this.inputData = 0; }

        this.sam.onSend({
          Command: 'GENERIC_INPUT',
          Callback: this.data.Callbackconfirm || 'GENERIC_INPUT',
          Val: this.inputData.toString(),
          descr: '',
          parms: {
            usrInp: this.inputData.toString(),
            decimals: this.inputOptions.decimals,
            reason: this.reasonData.toString() || null,
            reward: this.rewardData.toString() || null,
          },
        });
      }
    } else {
      this.sam.onSend({
        Command: 'GENERIC_INPUT',
        Callback: this.data.Callbackabort || 'CANCEL_INPUT',
        Val: '-1'
      });
    }
  }

  onKey(keyValue: any) {
    switch (keyValue) {
      case 'c':
        this.inputData = '';
        break;
      case 'b':
        this.inputData = this.inputData.substr(0, this.inputData.length - 1);
        break;
      default:
        this.inputData = `${this.inputData}${keyValue}`;
        break;
    }
  }

  // private

  private init() {
    this.inputOptions = {
      type: this.data.Type,
      value: this.data.Default || '',
      minLength: parseInt(String(this.data.Minlen), 10),
      maxLength: parseInt(String(this.data.Maxlen), 10),
      itemInd: this.data.ItemInd,
      integers: this.data.Integers || 0,
      decimals: this.data.Decimals || 0,
      valueLabel: this.data.ValueLabel || ' ',
    };

    if (['PERC'].includes(this.inputOptions.type)) {
      this.inputOptions.integers = 0;
      this.inputOptions.decimals = 0;
      this.inputOptions.valueLabel = '%';
    }

    this.divider = 10 ** this.inputOptions.decimals;
    this.digitsInfo = `${this.inputOptions.integers}.${this.inputOptions.decimals}-${this.inputOptions.decimals}`;
    this.valueLabel = this.inputOptions.valueLabel;

    if (['CURRENCY', 'NUMERICCURRENCY'].includes(this.inputOptions.type)) {
      this.valueLabel = this.configSvc.currency.name;
      this.divider = this.configSvc.currency.divider;
      this.digitsInfo = this.configSvc.currency.digitsInfo;
    }

    if (this.data.Rewards && this.data.Rewards[0]) {
      this.rewardData = this.data.Rewards[0].Id;
    }

    if (this.data.Reasons && this.data.Reasons[0]) {
      this.reasonData = this.data.Reasons[0].Id;
    }
  }

  private initKeyboard = (evt: any) => {
    const event = evt || window.event;
    let isEscape, isBackspace, isEnter;

    if ('key' in event) {
      isEscape = (event.key === 'Escape' || event.key === 'Esc');
      isBackspace = (event.key === 'Backspace' || event.key === 'Delete');
      isEnter = (event.key === 'Enter');
    } else {
      isEscape = (event.keyCode === 27);
    }

    try {
      const intKey = parseInt(event.key, 10);
      if (String(intKey) !== "NaN") {
        return this.onKey(intKey);
      }
    } catch (error) {
      
    }

    if (isBackspace) {
      return this.onKey('b');
    }

    if (isEnter) {
      return this.onCallback(true);
    } 

    if (isEscape) {
      return this.onCallback(false);
    } 
    
    return false;
  }

  private subscribeListeners() {
    // this.subscriptions.keyboard = this.sam.channels.dialogs.subscribe((msg: SAMMessage) => {
    //   // if (KeyboardDialogCommands.UPDATE_OSD.includes(msg.Command)) {
    //   //   const data: any = msg.parms;
    //   //   this.osdValue = data.value.toString();
    //   // }

    //   // if (msg.Command === KeyboardDialogCommands.UPDATE_SETTINGS) {
    //   //   const data: any = msg.parms;
    //   //   this.data.draggable = data.draggable || true;
    //   //   this.data.disabled = data.disabled || false;
    //   //   this.data.keys = data.keys;
    //   //   this.data.keysFlat = Helpers.flatten(this.data.keys);
    //   // }
    // });

    document.addEventListener('keydown', this.initKeyboard);
  }

  private unsubscribeListeners() {
    document.onkeydown = null;
    if (this.subscriptions.keyboard) { this.subscriptions.keyboard.unsubscribe(); }
  }
}
